import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
};
export const leverageReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.LEVERAGE.LEVERAGE_LIST: {
                return {
                    ...state,
                    listing: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default leverageReducer;
